const REFERENCE_TIME_FRAME = 14; /* days */

function getOffSiteMinBudget(
  baseBudget,
  additionalBudgetPerCountry,
  numberOfCountries,
  numberOfDays,
) {
  const additionalBudget = additionalBudgetPerCountry * (numberOfCountries - 1);
  const spendableBudget = baseBudget + additionalBudget;
  const minBudgetPerDay =
    spendableBudget / numberOfCountries / REFERENCE_TIME_FRAME;

  return minBudgetPerDay * numberOfDays * numberOfCountries;
}

function getOffSiteMinBudgetSpecification(
  base14DayBudget,
  additional14DayBudgetPerCountry,
) {
  return {
    baseBudget: base14DayBudget || 0,
    additionalBudgetPerCountry: additional14DayBudgetPerCountry || 0,
  };
}

// eslint-disable-next-line import/prefer-default-export
export { getOffSiteMinBudget, getOffSiteMinBudgetSpecification };
